import React, { useEffect, useState } from "react";
import actions from "../../redux/actions";
import { notifySuccess, notifyError } from "../ToastContext";

const ResultBetGameModal = ({ MarketId, MarketName, showModal, handleModalClose }) => {
  const [formData, setFormData] = useState({ MarketName: "", setResultNo: "" });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (showModal) {
      setFormData({ MarketName, setResultNo: "" });
      setErrors({});
    }
  }, [showModal, MarketName]);

  const handleInputChange = ({ target: { id, value } }) => {
    if (id === "setResultNo") {
      // Allow only numbers between 00-99
      if (/^\d{0,2}$/.test(value)) {
        setFormData((prev) => ({ ...prev, [id]: value }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [id]: value }));
    }
    setErrors((prev) => ({ ...prev, [id]: undefined }));
  };

  const validateForm = () => {
    const { setResultNo } = formData;
    const num = parseInt(setResultNo, 10);

    if (isNaN(num) || num < 0 || num > 99) {
      return { setResultNo: "Result must be between 00 and 99." };
    }

    return {};
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await actions.setSMResult({
          marketId: MarketId,
          resultNo: parseInt(formData.setResultNo, 10),
        });

        response?.data?.Status ? notifySuccess(response.data.Result) : notifyError(response.data.Result);
        handleModalClose();
      } catch (error) {
        console.error("Error:", error);
        notifyError("Something went wrong.");
      }
    }
  };

  return (
    showModal && (
      <div className="modal" id="createClientModal" tabIndex={-1} role="dialog" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Set Result</h6>
              <button className="close" type="button" aria-label="Close" onClick={handleModalClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group row">
                <div className="col-sm-6">
                  <label>Event Name</label>
                  <input type="text" className="form-control" value={formData.MarketName} disabled />
                </div>

                <div className="col-sm-6">
                  <label>Set Bet Result (00-99)</label>
                  <input
                    type="text"
                    className={`form-control ${errors.setResultNo ? "is-invalid" : ""}`}
                    id="setResultNo"
                    value={formData.setResultNo}
                    onChange={handleInputChange}
                    placeholder="Enter result (00-99)"
                    maxLength={2}
                  />
                  {errors.setResultNo && <div className="invalid-feedback">{errors.setResultNo}</div>}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleModalClose}>
                Close
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ResultBetGameModal;
